import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { ERROR_MSG, ROLE } from "../../../constants/common";
import {
    categoryToConnectionType,
    connectionTypeToCategory,
} from "../../../constants/InvestmentConstant";
import {
    PROPOSAL_UPDATE,
    SALES_PROPOSAL_BASE_ENDPOINT,
    SALES_PROPOSAL_UPDATE,
} from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import { checkIsAllowed } from "../../../helpers/helpers";

import { Form, Formik } from "formik";
import { IoIosArrowRoundBack } from "react-icons/io";
import { RESET_LOADER, SET_LOADER } from "../../../constants/contexConstant";
import cn from "../../../lib/cn";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import Section from "../../../shared/Section";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import DrawerAndModalWrapper from "../../../shared/ui/Drawer/DrawerAndModalWrapper";
import FormikLabeledTextArea from "../../../shared/ui/Form/FormikLabeledTextArea";
import LinedTab from "../../../shared/ui/tab/LinedTab";
import MasterDataWrapper from "../../admin/master-data/MasterDataWrapper";
import AdditionalInput from "../../property/AdditionalInput";
import GenerateProposal from "../../property/GenerateProposal";

const hasMoreThanOneDifference = (formData, initialData, newAdditional) => {
    if (
        JSON.stringify(initialData?.additionalItems) !==
        JSON.stringify(newAdditional)
    )
        return true;

    let diffCount = 0;

    for (const key of Object.keys(formData)) {
        if (key === "comment") continue;

        if (formData[key] !== initialData[key]) {
            diffCount++;
            if (diffCount > 0) {
                return true;
            }
        }
    }

    return false;
};

const RevisionProposal = () => {
    const { state, dispatch } = useContextState();
    const { plantId, proposalId } = useParams();
    const [isOpen, setIsOpen] = useState(false);
    const [durationOptions, setDurationOptions] = useState([
        { label: "5 Years", value: 5 },
        { label: "6 Years", value: 6 },
        { label: "7 Years", value: 7 },
        { label: "8 Years", value: 8 },
        { label: "9 Years", value: 9 },
        { label: "10 Years", value: 10 },
    ]);

    const masterDataRef = useRef();
    const proposalRef = useRef();

    const fetchData = `${SALES_PROPOSAL_BASE_ENDPOINT}/${plantId}/${
        proposalId ? proposalId : "current"
    }`;

    const [currentSlide, setCurrentSlide] = useState(0);

    const [showAdditionalModal, setShowAdditionalModal] = useState(false);
    const [additionalInput, setAdditionalInputs] = useState([]);

    const [selectedConnectionType, setSelectedConnectionType] = useState(
        connectionTypeToCategory.RESIDENTIAL_SOCIETY
    );

    const [initialData, setInitialData] = useState(null);
    const [formData, setFormData] = useState({
        category: "",
        consumerBill: "",
        consumerTotalUnits: "",
        plantDuration: "",
        subsidy: true,
        tenant: false,
        comment: "",
        data: "",
    });

    const initialCheckedState =
        selectedConnectionType === connectionTypeToCategory.RESIDENTIAL_SOCIETY
            ? { purchase: true, lease: true }
            : selectedConnectionType ===
                  connectionTypeToCategory.INDIVIDUAL_HOMES ||
              selectedConnectionType === connectionTypeToCategory.INDUSTRIAL
            ? { purchase: true, loan: true }
            : { purchase: true, lease: true, loan: true };

    const [checkedState, setCheckedState] = useState(initialCheckedState);

    let isAdmin = checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN]);
    let isSales = checkIsAllowed(state?.user?.roles, [ROLE.SALES_MANAGER]);

    const onClose = () => {
        setIsOpen(!isOpen);
    };
    const handleTabClick = (index) => {
        setCurrentSlide(index);
    };

    /* @DESC:: initial load @habib610 Tue May 13,2025 */
    useEffect(() => {
        const handleCurrentProposal = async () => {
            try {
                dispatch({ type: SET_LOADER });
                const response = await request.authGet({
                    endpoint: `${SALES_PROPOSAL_BASE_ENDPOINT}/${plantId}/${
                        proposalId ? proposalId : "current"
                    }`,
                });
                dispatch({ type: RESET_LOADER });
                const proposal = response.data.proposal;

                setAdditionalInputs(proposal?.additionalItems);

                let duration = Number(proposal.plantDuration) || "";

                let isExisting = durationOptions.find(
                    (item) => item.value === Number(duration)
                );

                let newDurationValue;

                if (!isExisting) {
                    newDurationValue = Number(Number(duration / 12).toFixed(1));
                    let allOptions = [
                        ...durationOptions,
                        {
                            label: `${newDurationValue} Years`,
                            value: newDurationValue,
                        },
                    ].sort((a, b) => a.value - b.value);
                    setDurationOptions(allOptions);
                }

                let category = proposal.category;
                let lease = proposal.lease === "REJECTED" ? false : true;
                let loan = proposal.loan === "REJECTED" ? false : true;
                let purchase = proposal.purchase === "REJECTED" ? false : true;

                setFormData({
                    category: (
                        connectionTypeToCategory[proposal.category] || ""
                    ).replace(/_/g, " "),
                    consumerBill: parseInt(proposal.consumerBill) || "",
                    consumerTotalUnits:
                        parseInt(proposal.consumerTotalUnits) || "",
                    plantDuration: isExisting ? duration : newDurationValue,
                    subsidy: proposal.subsidy || false,
                    tenant: proposal.tenant || false,
                    data: proposal?.data,
                    comment: "",
                    lease: lease,
                    loan: loan,
                    purchase: purchase,
                });
                setSelectedConnectionType(
                    (connectionTypeToCategory[proposal.category] || "").replace(
                        /_/g,
                        " "
                    )
                );

                setInitialData({
                    category: (
                        connectionTypeToCategory[proposal.category] || ""
                    ).replace(/_/g, " "),
                    consumerBill: parseInt(proposal.consumerBill) || "",
                    consumerTotalUnits:
                        parseInt(proposal.consumerTotalUnits) || "",
                    plantDuration: isExisting ? duration : newDurationValue,
                    subsidy: proposal.subsidy || false,
                    tenant: proposal.tenant || false,
                    comment: "",
                    data: proposal?.data,
                    additionalItems: proposal?.additionalItems,
                    lease: lease,
                    loan: loan,
                    purchase: purchase,
                });

                setCheckedState(
                    category ===
                        categoryToConnectionType[
                            connectionTypeToCategory.RESIDENTIAL_SOCIETY
                        ]
                        ? { purchase: purchase, lease: lease }
                        : category ===
                              categoryToConnectionType[
                                  connectionTypeToCategory.INDIVIDUAL_HOMES
                              ] ||
                          category ===
                              categoryToConnectionType[
                                  connectionTypeToCategory.INDUSTRIAL
                              ]
                        ? { purchase: purchase, loan: loan }
                        : { purchase: purchase, lease: lease, loan: loan }
                );
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                toast.error("Failed to fetch initial data");
            }
        };

        if (plantId) {
            handleCurrentProposal();
        }
    }, [dispatch, plantId, proposalId]);

    const history = useHistory();

    const editData = checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN])
        ? `${PROPOSAL_UPDATE}/${plantId}`
        : `${SALES_PROPOSAL_UPDATE}/${plantId}`;

    const isServerCalculation =
        selectedConnectionType ===
            connectionTypeToCategory.RESIDENTIAL_SOCIETY ||
        selectedConnectionType === connectionTypeToCategory.INDIVIDUAL_HOMES;

    const fetchBillAmount = async (units) => {
        try {
            dispatch(SET_LOADER);
            if (isServerCalculation && !isNaN(units)) {
                let res = await request.authGet({
                    endpoint: `${SALES_PROPOSAL_BASE_ENDPOINT}/getBill/residential/${units}`,
                });
                let bill = parseInt(res?.data?.billAmount);
                if (bill) {
                    setFormData((prev) => ({ ...prev, consumerBill: bill }));
                } else {
                    toast.error(
                        "Can't fetch bill amount. Please try again later"
                    );
                }
            }
            dispatch(RESET_LOADER);
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch(RESET_LOADER);
        }
    };

    useEffect(() => {
        setCheckedState(
            selectedConnectionType ===
                connectionTypeToCategory.RESIDENTIAL_SOCIETY
                ? { purchase: true, lease: true }
                : selectedConnectionType ===
                      connectionTypeToCategory.INDIVIDUAL_HOMES ||
                  selectedConnectionType === connectionTypeToCategory.INDUSTRIAL
                ? { purchase: true, loan: true }
                : { purchase: true, lease: true, loan: true }
        );
    }, [selectedConnectionType]);

    const handleCheckboxChange = (key) => {
        const checkedCount = Object.values(checkedState).filter(Boolean).length;

        setCheckedState((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
        setFormData((prev) => ({ ...prev, [key]: !prev[key] }));

        if (checkedCount === 1 && checkedState[key]) {
            toast.warn("At least one option must remain selected.");
        }
    };

    const handleTotalUnitsChange = (e) => {
        let value = e.target.value;
        setFormData((prev) => ({ ...prev, consumerTotalUnits: value }));
        fetchBillAmount(value);
    };
    const handleConsumerBill = (e) => {
        let value = e.target.value;
        setFormData((prev) => ({ ...prev, consumerBill: value }));
    };
    const handleConnectionTypeChange = (selected) => {
        setSelectedConnectionType(selected);
        setFormData((prev) => ({ ...prev, category: selected }));
    };

    const handleUpdateProposal = async (values, actions) => {
        let { data } = masterDataRef?.current?.getAllState() || {};

        const updatedData = {};

        if (checkedState["purchase"] || checkedState["loan"]) {
            updatedData.additionalItems =
                additionalInput?.length === 0
                    ? []
                    : additionalInput.map((item) => ({
                          ...item,
                          itemPrice: parseInt(item.itemPrice),
                      }));
        }

        for (const key in formData) {
            if (formData[key] !== initialData[key] && key !== "comment") {
                if (key === "category") {
                    updatedData[key] =
                        categoryToConnectionType[formData.category];
                } else if (
                    (key === "lease" || key === "purchase" || key === "loan") &&
                    key in checkedState
                ) {
                    updatedData[key] =
                        formData[key] === true ? "APPROVED" : "REJECTED";
                } else {
                    updatedData[key] = formData[key];
                }
            }
        }
        updatedData.comment = values.comment;

        let masterDataProperties = data;
        if (
            masterDataProperties &&
            checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN])
        ) {
            const submitDataString = masterDataProperties;

            if (submitDataString !== initialData?.data)
                updatedData.data = submitDataString;
        }

        try {
            if (isAdmin) {
                if (
                    hasMoreThanOneDifference(
                        updatedData,
                        initialData,
                        additionalInput
                    )
                ) {
                    dispatch({ type: SET_LOADER });
                    await request.authPut({
                        endpoint: `${PROPOSAL_UPDATE}/${plantId}`,
                        body: updatedData,
                    });

                    dispatch({ type: RESET_LOADER });
                }
            } else {
                dispatch({ type: SET_LOADER });
                await request.authPut({
                    endpoint: `${SALES_PROPOSAL_UPDATE}/${plantId}`,
                    body: updatedData,
                });
                dispatch({ type: RESET_LOADER });
            }
            setIsOpen(false);
            actions.resetForm();
            toast.success("Proposal updated successfully");
            history.goBack();
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            toast.error(typeof error === "string" ? error : ERROR_MSG);
        }
    };

    const handleSubmit = () => {
        const state = masterDataRef?.current?.getAllState?.();
        if (!state && isAdmin) {
            toast.error("Master data state not available");
            return;
        } else if (state) {
            const { isValid } = state;

            if (!isValid && isAdmin) {
                toast.error("Fix all master data errors");
                return;
            }
        }
        if (!initialData) {
            toast.error("Failed to fetch initial data");
            return;
        }
        setIsOpen(true);
    };

    return (
        <Section>
            <div className="min-h-[128px] bg-primary lg:hidden"></div>
            <div className="pt-4 rounded-3 bg-white -mt-3 pb-1 lg:pt-12 ">
                <Container>
                    <div className=" bg-white  md:min-h-[900px] lg:flex items-start lg:mt-4  gap-1">
                        <div
                            role="button"
                            onClick={() => history.goBack()}
                            className="lg:flex items-center gap-0.4 hidden cursor-pointer"
                        >
                            <IoIosArrowRoundBack size={28} /> <P> Back</P>
                        </div>
                        <div>
                            <div className="lg:hidden">
                                <LinedTab
                                    className="pb-0 mb-2.4 border-b border-b-blue-200 mt-0 pt-0 w-full"
                                    activeClass={
                                        "text-blue font-medium duration-300"
                                    }
                                    inActiveClass={"text-gray-370"}
                                    data={
                                        isAdmin
                                            ? ["Configuration", "Master data"]
                                            : isSales
                                            ? ["Configuration"]
                                            : []
                                    }
                                    activeTab={currentSlide}
                                    onClick={handleTabClick}
                                />
                            </div>
                        </div>
                        <div className=" pb-6 lg:flex lg:gap-2.4 xl:gap-4 justify-between lg:pb-0 flex-1">
                            <div
                                className={cn(
                                    "bg-white w-full  mt-2 rounded-sm lg:block lg:mt-0 lg:w-[40%] xl:w-[35%] lg:shadow-lg lg:p-2.4 lg:rounded-2",
                                    {
                                        hidden: currentSlide === 1,
                                    }
                                )}
                            >
                                <GenerateProposal
                                    selectedConnectionType={
                                        selectedConnectionType
                                    }
                                    onConnectionTypeChange={
                                        handleConnectionTypeChange
                                    }
                                    durationOptions={durationOptions}
                                    consumersBill={formData.consumerBill}
                                    totalUnits={formData.consumerTotalUnits}
                                    handleConsumerBill={handleConsumerBill}
                                    onTotalUnitsChange={handleTotalUnitsChange}
                                    setIsOpen={setIsOpen}
                                    planDuration={formData.plantDuration}
                                    handleSubsidyChange={(val) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            subsidy: val === "Yes",
                                        }))
                                    }
                                    propertyList={[
                                        {
                                            label: "Residential Society",
                                            value: "Residential Society",
                                        },
                                        {
                                            label: "Commercial",
                                            value: "Commercial",
                                        },
                                        {
                                            label: "Industrial",
                                            value: "Industrial",
                                        },
                                        {
                                            label: "Individual Homes",
                                            value: "Individual Homes",
                                        },
                                    ]}
                                    subsidy={formData.subsidy}
                                    showReAssign={false}
                                    showSubsidy={true}
                                    checkedState={checkedState}
                                    handleCheckboxChange={handleCheckboxChange}
                                    showAdditionalModal={showAdditionalModal}
                                    onChangeAdditionalModal={() =>
                                        setShowAdditionalModal((prev) => !prev)
                                    }
                                    onPlanDurationChange={(val) =>
                                        setFormData({
                                            ...formData,
                                            plantDuration: val,
                                        })
                                    }
                                    ref={proposalRef}
                                />
                                <Button
                                    className="hidden w-full lg:flex mt-2"
                                    onClick={handleSubmit}
                                    disabled={
                                        !hasMoreThanOneDifference(
                                            formData,
                                            initialData,
                                            additionalInput
                                        ) ||
                                        !Object.values(checkedState).filter(
                                            Boolean
                                        ).length
                                    }
                                >
                                    Update
                                </Button>
                            </div>

                            {isAdmin && (
                                <div
                                    className={cn(
                                        "lg:block lg:flex-1 lg:shadow-xl lg:p-2.4 lg:rounded-2",
                                        {
                                            hidden: currentSlide === 0,
                                        }
                                    )}
                                >
                                    <div className="mt-2 lg:mt-0">
                                        <MasterDataWrapper
                                            ref={masterDataRef}
                                            endpoint={fetchData}
                                            updateEndpoint={editData}
                                            showButton={false}
                                            onDataChange={(data) =>
                                                setFormData({
                                                    ...formData,
                                                    data: data,
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="lg:hidden fixed inset-x-0 bottom-6 bg-white py-2">
                            <Container>
                                <Button
                                    className="w-full"
                                    onClick={handleSubmit}
                                    disabled={
                                        !hasMoreThanOneDifference(
                                            formData,
                                            initialData,
                                            additionalInput
                                        ) ||
                                        !Object.values(checkedState).filter(
                                            Boolean
                                        ).length
                                    }
                                >
                                    Update
                                </Button>
                            </Container>
                        </div>

                        <DrawerAndModalWrapper
                            isOpen={isOpen}
                            onClose={onClose}
                            modalContentClass="bg-white"
                        >
                            <div className="mt-1 lg:mt-0">
                                <Formik
                                    onSubmit={handleUpdateProposal}
                                    initialValues={{
                                        comment: "",
                                    }}
                                    validationSchema={yup.object().shape({
                                        comment: yup
                                            .string()
                                            .required()
                                            .min(10)
                                            .max(240)
                                            .label("Comment"),
                                    })}
                                >
                                    {() => (
                                        <Form>
                                            <FormikLabeledTextArea
                                                name="comment"
                                                label="Admin's Comment"
                                                rows="6"
                                                remaining={10}
                                            />
                                            <Button
                                                className="w-full"
                                                type="submit"
                                            >
                                                Submit
                                            </Button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </DrawerAndModalWrapper>
                    </div>
                </Container>
            </div>
            <AdditionalInput
                onClose={setShowAdditionalModal}
                isOpen={showAdditionalModal}
                inputs={additionalInput}
                setInputs={setAdditionalInputs}
                // onQuitModal={onQuitModal}
                isAllDeletable
            />
        </Section>
    );
};

export default RevisionProposal;
